import Vue from 'vue'
import Vuex from 'vuex'
import dnet from './dnet'
import user from './user'
import chats from './chats'
import exhibitions from './exhibitions'
import contests from './contests'
import articles from './articles'
import teams from './teams'
import auth from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    dnet,
    user,
    chats,
    exhibitions,
    contests,
    articles,
    teams,
    auth,
  }
})
